import {connect} from "react-redux";
import {matchPath, withRouter} from "react-router-dom";
import loremIpsumText from "lorem-ipsum";
// import badWords from "./badWords";
import moment from "moment";
import * as cookie from "react-cookies";
import React from "react";


//<editor-fold desc="Object Helpers">
//Find an element in an object
export function objectFind(obj, callback) {
	for (let key in obj) {
		if (!obj.hasOwnProperty(key)) continue;
		if (callback(obj[key]))
			return obj[key];
	}
	return null;
}

export function objectFindKey(obj, callback) {
	for (let key in obj) {
		if (!obj.hasOwnProperty(key)) continue;
		if (callback(obj[key]))
			return key;
	}
	return null;
}

//Filters out props from an object
export function objectFilter(obj, callback) {
	let ret = {};
	for (let key in obj) {
		if (!obj.hasOwnProperty(key)) continue;
		if (callback(obj[key], key))
			ret[key] = obj[key];
	}
	return ret;
}

//Compares two objects and returns true if they are equal
export function objectCompare(obj1, obj2, properties = []) {
	if (properties.length < 1) {
		
		if (Object.keys(obj1).length !== Object.keys(obj2).length)
			return false;
		
		for (let key in obj1) {
			if (!obj1.hasOwnProperty(key)) continue;
			if (obj1[key] !== obj2[key])
				return false;
		}
	} else {
		
		for (let key in properties) {
			if (!properties.hasOwnProperty(key)) continue;
			let prop = properties[key];
			if (obj1[prop] !== obj2[prop])
				return false;
		}
	}
	return true;
}

//Merges non null from object into the first
export function objectMerge(obj1, obj2, obj3 = {}) {
	return Object.assign({}, obj1 || {}, objectFilter(obj2 || {}, x => x != null), objectFilter(obj3 || {}, x => x != null));
}

//Loops though an object
export function forEachObj(obj, callback) {
	let index = 0;
	for (let key in obj) {
		if (!obj.hasOwnProperty(key)) continue;
		callback(obj[key], key, index);
		index++;
	}
}

export function isEmpty(obj) {
	return obj == null || Object.keys(obj).length < 1;
}
//</editor-fold>

//<editor-fold desc="Mapping Tools">

//Converts an array into an object
export function arrayToObject(array = [], keyProp = "id") {
	let ret = {};
	for (let key in array) {
		if (!array.hasOwnProperty(key)) continue;
		
		if (array[key].hasOwnProperty(keyProp))
			ret[array[key][keyProp]] = array[key];
	}
	return ret;
}

//converts an object into an array
export function objectToArray(object, start = 0, length = null, keyProp = "id") {
	let ret = [];
	let i = 0;
	for (let key in object) {
		if (!object.hasOwnProperty(key)) continue;

		i++;
		if (i <= start) continue;
		if (length && i > start + length) break;

		let item = object[key];

		if (typeof item === "object" && !Array.isArray(item))
			ret.push(Object.assign({}, item, {[keyProp]: key}));
		else
			ret.push({[keyProp]: key, data: item});
	}
	return ret;
}

//Maps an object to another object
export function mapObject(object, callback, keepNull = false) {
	let ret = {};
	if (typeof callback !== "function") return ret;
	
	for (let key in object) {
		if (!object.hasOwnProperty(key)) continue;
		let val = callback(object[key], key);
		if (keepNull || val) {
			if (val && typeof val === "object" && val.hasOwnProperty("key"))
				ret[val.key] = val.data || val.props || null;
			else
				ret[key] = val;
		}
	}
	return ret;
}

//Iterated through an object and returns an array
export function mapObjectToArray(object, callback, sort) {
	let ret = [];
	if (typeof callback !== "function") return ret;
	let index = 0;
	
	for (let key in object) {
		if (!object.hasOwnProperty(key)) continue;
		let val = callback(object[key], key, index);
		index++;
		if (val)
			ret.push({val, order: sort ? object[key][sort] : index});
	}
	
	if (sort) {
		ret = ret.sort((a, b) => a.order < b.order ? -1 : (b.order < a.order ? 1 : 0))
	}
	
	return ret.map(x => x.val);
}

//Maps an array and filters out null values
export function mapArray(array, callback) {
	let ret = [];
	
	for (let key in array) {
		if (!array.hasOwnProperty(key)) continue;
		let res = callback(array[key], key);
		if (res) ret.push(res)
	}
	
	return ret;
}

//Iterates through an array and returns an object
export function mapArrayToObject(array, callback) {
	let ret = {};
	if (typeof callback !== "function") return ret;
	
	array.forEach(x => {
		let res = callback(x);
		if (res != null) {
			if (typeof res === "object" && res.hasOwnProperty("key"))
				ret[res.key] = res.data || res.value || res.props || null;
			else
				ret[x] = res;
		}
	});
	return ret;
}



//Extracts the name from from an object
export function mapObjectName(object, prop) {
	let ret = {};
	
	for (let key in object) {
		if (!object.hasOwnProperty(key)) continue;
		ret[object[key].id] = object[key][prop || "name"];
	}
	return ret;
}

//Maps through an array of a given length
export function mapNumber(num, callback) {
	let ret = [];
	
	for (let i = 0; i < num; i++) {
		ret.push(callback(i));
	}
	return ret;
}

//A map function that counts the returns and returns the sum
export function countMap(obj, callback) {
	let count = 0;
	for (let key in obj) {
		if (!obj.hasOwnProperty(key)) continue;
		count += callback(obj[key], key);
	}
	return count;
}
//</editor-fold>

//<editor-fold desc="Scroll">
//Scrolls to an element on the page
let scrollTimeout;

export function scrollTo(ref, options = {}) {
	if (!ref) return;

	clearTimeout(scrollTimeout);
	let newOptions = Object.assign({
		delay: 0,
		duration: 1000,
		offset: 0
	}, options);

	if (Math.abs(((ref.offsetTop + newOptions.offset) - document.getElementById('header').scrollHeight) - document.getElementById('content').scrollTop) < 2)
		return;

	scrollTimeout = setTimeout(function () {
		let start = document.getElementById('content').scrollTop;
		let currentTime = 0;
		let increment = 15;
		let change;

		let animateScroll = function () {
			currentTime += increment;
			change = ((ref.offsetTop + newOptions.offset) - document.getElementById('header').scrollHeight) - start;
			document.getElementById('content').scrollTop = Math.easeInOutQuad(currentTime, start, change, newOptions.duration);
			if (currentTime < newOptions.duration) {
				scrollTimeout = setTimeout(animateScroll, increment);
			}
		};
		animateScroll();
	}, newOptions.delay)

}

Math.easeInOutQuad = function (t, b, c, d) {
	t /= d / 2;
	if (t < 1) return c / 2 * t * t + b;
	t--;
	return -c / 2 * (t * (t - 2) - 1) + b;
};
//</editor-fold>

//An override for connecting redux without breaking react router
export function reduxConnect(stateFunc = null, dispatchFunc = null) {
	return comp => withRouter(connect(stateFunc, dispatchFunc)(comp));
}

//Tests if the given react router path is currently visited
export function testPath(path, props = {}) {
	return matchPath(window.location.pathname, {path: path, ...props});
}

//Seralizes an object into a GET query
export function serializeQuery(object, prefix) {
	let str = [];
	for (let key in object) {
		if (!object.hasOwnProperty(key)) continue;
		let prop = prefix ? prefix + "[" + key + "]" : key;
		let value = object[key];

		if (value == null) continue;

		str.push(typeof value === "object" ?
			serializeQuery(value, prop) :
			encodeURIComponent(prop) + "=" + encodeURIComponent(value));
	}
	return str.join("&");
}

//Creates a GUID
export function guid() {
	function s4() {
		return Math.floor((1 + Math.random()) * 0x10000)
			.toString(16)
			.substring(1);
	}

	return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

//creates a new react router path based on the current path
export function relativePath(path) {
	//Clean path
	path = path.toString().replace(/(?:^\/*|\/*$)/g, "");

	//Split current path
	let currentPath = window.location.pathname.replace(/(?:^\/*|\/*$)/g, "").split("/");

	let backtracks = path.match(/\.\.\/?/g) || [];

	if (backtracks.length < 1) {
		let dots = path.match(/\.\/?/g) || [];

		if (dots.length > 0) {
			path = path.replace(/\.\/?/g, "");
			currentPath = currentPath.slice(0, Math.max(0, dots.length));
		}
	} else {
		path = path.replace(/\.\.\/?/g, "");
		currentPath = currentPath.slice(0, Math.max(0, currentPath.length - backtracks.length));
	}
	currentPath = currentPath.join("").length > 0 ? "/" + currentPath.join("/") : "";
	return currentPath + (path.length > 0 ? "/" + path : "");
}


//Generates a random Lorem Ipsum text
const loremIpsumSettings = {
	sentenceLowerBound: 10,
	sentenceUpperBound: 12,
	paragraphLowerBound: 4,
	paragraphUpperBound: 5,
	//words: badWords
};

export function loremIpsum(length = "medium") {
	switch (length.toLocaleLowerCase()) {
		case "small":
			return loremIpsumText({...loremIpsumSettings, count: 7, units: "words"});
		default:
		case "medium":
			return loremIpsumText({...loremIpsumSettings, count: 2, units: "sentences"});
		case "big":
			return loremIpsumText({...loremIpsumSettings, count: 1, units: "paragraph"});
		case "massive":
			return loremIpsumText({...loremIpsumSettings, count: 2, units: "paragraph"});
	}
}

//Formats price to the correct danish format
export function formatPrice(price) {
	return parseFloat(price).toLocaleString("da-dk", {style: "currency", currency: "DKK"}).replace("kr.", "")
}

export function formatTime(time, onlyDate = false, simple = false) {
	if (time == null) return "Dato";
	if (!moment.isMoment(time)) time = moment(time);
	
	if (onlyDate) return simple ? time.format("DD/MM YYYY") : time.format("D. MMMM YYYY");
	return time.format("DD/MM - YYYY, hh:mm");
}

//Finds the nearest matching parent
export function nearestClass(element, c) {
	if (element == null)
		return null;

	let parent = element;
	let top = 0;
	let left = 0;
	let success = true;

	while (!parent.classList.contains(c)) {
		if (parent.tagName === "body")
			return null;

		top += parent.offsetTop;
		left += parent.offsetLeft;
		parent = parent.parentElement;

		if (parent == null)
			return null;
	}

	return {
		success: success,
		parent: parent,
		element: element,
		top: top,
		left: left
	}
}


//Extracts usable data from the cart
let cachedProducts = [];

export function extractCartData(cartItems, products, onCache, section) {
	let total = 0;
	let forCache = [];

	let newProducts = mapObjectToArray(cartItems, x => {
		if (section && parseInt(x.section, 10) !== section)
			return null;

		let price = 0;
		let config = null;
		const prodId = x.productId || x.id;
		const product = products[prodId] || {};

		if (product && product.full) {
			config = product.configurations && x.configurationId && product.configurations.find(y => y.id === x.configurationId);
			price = config ? config.price : product.price;
		} else if (!cachedProducts.includes(prodId)) {
			cachedProducts.push(prodId);
			forCache.push(prodId);
			price = product.price || 0;
		}

		total += x.qty * price;

		return Object.assign({}, x, {product: product, price: price, config: config});
	});

	if (onCache && forCache.length > 0)
		onCache({products: forCache, full: true});

	return {total: total, products: newProducts}
}

//An abstraction making it easier to extract data from the cart
export function extractCartDataEZ(state, dispatch, section) {
	const onCache = (ids) => dispatch({standard: true, group: "products", type: "cache", args: {products: ids, full: true}});
	return extractCartData(state.cart, state.products, onCache, section)
}

//Pads a number
export function padNumber(num, pad) {
	return num.toString().padStart(pad, "0");
}

//Returns the amount of product in a giving section from the cart
export function cartCount(products, unit = null, defaultUnit = 1) {
	let count = 0;
	for (let key in products) {
		if (!products.hasOwnProperty(key)) continue;
		const item = products[key];
		if (!item.product) continue;
		
		if (unit) {
			if (item.product.info) count += (item.product.info[unit] || defaultUnit) * item.qty;
		} else {
			count += item.qty || 0
		}
	}
	return count;
}

export function cartCountType(products, type) {
	let count = 0;
	for (let key in products) {
		if (!products.hasOwnProperty(key)) continue;
		const item = products[key];
		if (!item.product) continue;
		
		if (item.product.productType === type) {
			count += item.qty || 0
		}
	}
	return count;
}

export function cartTypes(products, types, unit = null, defaultUnit = 1) {
	const sortedTypes = {};
	for (let key in products) {
		if (!products.hasOwnProperty(key)) continue;
		const item = products[key];
		if (!item.product) continue;
		
		let type = item.product.productType || 0;
		if (!types[type]) type = 0;
		
		if (!types.hasOwnProperty(type)) continue;
		unit = types[type].unit || unit;
		
		let num;
		if (unit) {
			if (item.product.info) num = (item.product.info[unit] || defaultUnit) * item.qty
		} else {
			num = item.qty || 0
		}
		
		if (num) {
			sortedTypes[type] = (sortedTypes[type] || 0) + num;
		}
	}
	
	const ret = [];
	for (let key in sortedTypes) {
		if (!sortedTypes.hasOwnProperty(key)) continue;
		const type = types[key];
		ret.push({text: type.text, icon: type.icon, qty: type.change ? type.change(sortedTypes[key]) : sortedTypes[key]});
	}
	return ret;
}

export function getSubsectionFromSections(sections, id) {
	let subsection;
	for (let key in sections) {
		if (!sections.hasOwnProperty(key)) continue;
		subsection = sections[key].children.find(x => x.id === id);
		if (subsection)
			return {section: sections[key], subsection};
	}
	return {section: undefined, subsection: undefined};
}

//Slices an array to match a page in pagination
export function slicePage(array, page, itemsPerPage) {
	return array.slice(page * itemsPerPage, page * itemsPerPage + itemsPerPage) || [];
}



//A function for generating a callback to change nested state the raw function
export function changeStateRaw(origin, nesting, value, first = true) {
	if (nesting.length < 1)
		return value;
	const prop = nesting.splice(0, 1)[0];
	if (prop === "PUSH")
		return [...origin, value];
	if (first)
		return {[prop]: changeStateRaw(origin[prop] || {}, nesting, value, false)};
	return Object.assign({}, origin, {[prop]: changeStateRaw(origin[prop] || {}, nesting, value, false)});
}

//A function for generating a callback to change nested state
export function changeState(nesting, value) {
	return prev => changeStateRaw(prev, nesting, value)
}

//Clamp a number between a max and a min
export function clamp(num, min, max) {
	return Math.max(min, Math.min(max, num));
}


export function getProductHours(products, options) {
	return products.reduce((acc, x) => {
		if (!x.product.configurations) return acc;
		const conf = x.product.configurations.find(y => y.id === x.configurationId);
		if (!conf || !conf.options) return acc;
		const optionId = conf.options.find(y => y.attributeId === 12);
		const option = options[optionId ? optionId.optionId : 0];
		if (!option) return acc;
		const match = option.match(/^\s*(\d+)\s+time/i);
		return  acc + (match ? parseInt(match, 10) : 0);
	}, 0);
}

export function toggleState(param) {
	return prev => ({[param]: !prev[param]});
}

export function getNestedValue(obj, array) {
	array = Array.isArray(array) ? array : [array];
	if (array.length > 0) {
		const value = obj[array[0]];
		if (value == null || array.length === 1)
			return value;
		return getNestedValue(value, array.slice(1));
	} else
		return null;
}

export function partitionObject(obj, param) {
	let ret = {};
	for (let key in obj) {
		if (!obj.hasOwnProperty(key)) continue;
		let val = getNestedValue(obj[key], param);
		if (val != null)
			if (val === true) val = 1;
			if (val === false) val = 0;
			ret[val] = ret[val] ? [...ret[val], obj[key]] : [obj[key]];
	}
	return ret;
}

export function isLive() {
	return window.location.hostname.substr(0, 9) !== "localhost"
}

export function upperFirst(string) {
	return string.charAt(0).toUpperCase() + string.slice(1)
}

export function lowerFirst(string) {
	return string.charAt(0).toLowerCase() + string.slice(1)
}

export function historyPrev(history) {
	if (!history.goBack()) history.replace(relativePath(".."))
}

export function objLength(obj) {
	return obj ? Object.keys(obj).length : 0;
}

export function objGetKey(obj, index) {
	const keys = Object.keys(obj);
	return index === -1 ? keys[keys.length - 1] : keys[index];
}

export function saveUserToken(token) {
	const date = new Date();
	date.setDate(date.getDate() + 7);
	cookie.save("userToken", token, {path: "/", expires: date});
}

export function isIE() {
	return /*@cc_on!@*/!!document.documentMode
}

export function saveMessage() {
	let messages = [
		"*pling* SAVED *pling*",
		"I guess the thing is saved now... *sigh*...",
		"O boy, what wonderful news I have for you: IT'S SAVED!",
		"The item has been saved good sir.",
		"Saved",
		"Bob's your uncle, it's saved.",
		"Psssst... Wanna know a secret. I saved your thing.",
		"HOLY SHIT! IT WORKED?!?!",
		"What has 0 thumbs and just saved your item? ME!",
		"I have been a good boy, I saved your thingy!",
		"Sorry for the wait, but your item is now saved.",
		"S A V E D",
		"It's done, you can leave now...",
		"Congrats, it's a... Non binary gender fluid thing. I saved it!"
	];
	return messages[parseInt(Math.random() * messages.length, 10)];
}

export function sortTable(rows, columns, sortCol = "id", sortAsc = true) {
	return rows.sort((a, b) => {
		let aVal = a[columns[sortCol].propName || sortCol];
		let bVal = b[columns[sortCol].propName || sortCol];
		if (columns[sortCol].parse) {
			aVal = columns[sortCol].parse(aVal);
			bVal = columns[sortCol].parse(bVal);
		}
		if (aVal === bVal) return 0;
		return (aVal < bVal ? -1 : 1) * (sortAsc ? 1 : -1);
	})
}

export function sectionsToSubsections(sections, mapName = false) {
	let subsections = {};
	forEachObj(sections, x => x.children.forEach(y => subsections[y.id] = mapName ? y.title : y));
	return subsections;
}


// WEBPACK FOOTER //
// ./src/lib/tools.js